import values from 'lodash/values';
import ListingType, { RentListingTypeKeys, SaleListingTypeKeys } from './listing-type';
export var PropertyStatusKeys = ['FOR_SALE', 'UNDER_OFFER', 'SOLD', 'AVAILABLE_FOR_RENT', 'UNDER_APPLICATION', 'RENTED'];
var PropertyStatusValues = {
  FOR_SALE: {
    name: 'FOR_SALE',
    residentialLabel: 'For Sale',
    commercialLabel: 'For Sale',
    digitalDataKey: 'For Sale',
    urlSlug: 'for-sale',
    listingTypes: [...SaleListingTypeKeys, ListingType.DEVELOPMENTS_RESIDENTIAL.name]
  },
  UNDER_OFFER: {
    name: 'UNDER_OFFER',
    residentialLabel: 'Under Offer',
    commercialLabel: 'Under Offer',
    digitalDataKey: 'Under Offer',
    urlSlug: 'under-offer',
    listingTypes: [...SaleListingTypeKeys, ListingType.DEVELOPMENTS_RESIDENTIAL.name]
  },
  SOLD: {
    name: 'SOLD',
    residentialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Include sold (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Sold',
    urlSlug: 'sold',
    listingTypes: [...SaleListingTypeKeys, ListingType.DEVELOPMENTS_RESIDENTIAL.name]
  },
  AVAILABLE_FOR_RENT: {
    name: 'AVAILABLE_FOR_RENT',
    residentialLabel: 'For Rent',
    commercialLabel: 'For Lease',
    digitalDataKey: 'For Rent',
    urlSlug: 'for-rent',
    listingTypes: RentListingTypeKeys
  },
  UNDER_APPLICATION: {
    name: 'UNDER_APPLICATION',
    residentialLabel: 'Under Application',
    commercialLabel: 'Under Application',
    digitalDataKey: 'Under Application',
    urlSlug: 'under-application',
    listingTypes: RentListingTypeKeys
  },
  RENTED: {
    name: 'RENTED',
    residentialLabel: 'Rented (last %LISTING_VISIBILITY%)',
    commercialLabel: 'Leased (last %LISTING_VISIBILITY%)',
    digitalDataKey: 'Rented',
    urlSlug: 'rented',
    listingTypes: RentListingTypeKeys
  }
};
var PropertyStatus = PropertyStatusValues;
export var getPropertyStatusForType = listingType => values(PropertyStatus).filter(each => each.listingTypes.includes(listingType));
export default PropertyStatus;